const editorsPicksEl = document.querySelector('.blog__editors-picks__slider')
const editorsPicksSlider =
  typeof Swiper !== 'undefined' && editorsPicksEl
    ? new Swiper('.blog__editors-picks__slider', {
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    : null

function stripLSepTopTitle() {
  const topTitle = document.querySelectorAll('.top-title')
  if (!topTitle) {
    return
  }
  topTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

function stripLSepArticleTitle() {
  const articleTitle = document.querySelectorAll('.article-title')
  if (!articleTitle) {
    return
  }
  articleTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

function stripLSepEditorsTitle() {
  const editorsTitle = document.querySelectorAll('.editors-title')
  if (!editorsTitle) {
    return
  }
  editorsTitle.forEach((title) => {
    title.innerHTML = title.innerHTML.replace(/\u2028/g, '')
  })
}

stripLSepEditorsTitle()
stripLSepArticleTitle()
stripLSepTopTitle()
